// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/cssWithMappingToString.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".selected-car-image img[data-v-ae2f4c46]{max-width:234px}", "",{"version":3,"sources":["webpack://./resources/js/components/OrderForm.vue"],"names":[],"mappings":"AAEC,yCACC,eADF","sourcesContent":["\n.selected-car-image{\n\timg{\n\t max-width: 234px;\n\t}\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
